// extracted by mini-css-extract-plugin
module.exports = {"fields":"ContactFields_fields__IVa_I","isSingleNameField":"ContactFields_isSingleNameField__3mGRG"};